import { ICheckPaymentByProviderResponse } from '../../../../repositories/billing-payments/v1/check-payment-by-provider';
import { IPaymentStatus, EPaymentStatus } from '../types';

export const mapResponse200 = (response: ICheckPaymentByProviderResponse): IPaymentStatus => {
  const { status } = response;

  return { status: status as string as EPaymentStatus, message: null };
};
